import { HttpClientService } from '../common/network/HttpClientService'
import { type OperationResult } from '../common/errors/OperationResult'
import * as op from '../common/errors/OperationResult'

export interface AppInfoModel {
  commit: string
  builtAt: string
  env?: string
}

export class AppInfoApiService {
  constructor(private readonly httpClientService: HttpClientService) {}

  public async getServerAppInfo(): Promise<OperationResult<AppInfoModel>> {
    const { result, error } = await this.httpClientService.sendRequest('/version', 'GET', {
      skipAuth: true,
    })
    if (error) {
      return op.error(error)
    }
    return op.success(result as AppInfoModel)
  }
}
